/* eslint-disable no-unused-vars */
/* eslint-disable no-console */
import { useEffect, useState } from 'react';
import { getSingleProjectService } from 'services';
import { projectIsCollecting } from 'util/projectStatusFilter';
import { odsOrganized } from 'types';
import { useCancelToken } from '../useCancelToken';

export const useSingleProject = ({ tag = null, id = null }) => {
  const [state, setState] = useState(null);
  const [isError, setIsError] = useState(false);
  const [isLoading, setIsLoading] = useState(false);

  const { isMounted, source, logCallback } = useCancelToken();
  useEffect(() => {
    if (tag || id) {
      setIsLoading(true);
      setState(null);
      getSingleProjectService({ tag, id, source })
        .then((data) => {
          if (isMounted) {
            setIsLoading(false);
            if (
              projectIsCollecting(
                data.status, data.currentAmount, data.minAmount, data.maxAmount, data.endDate,
              )
            ) {
              /* eslint-disable-next-line no-param-reassign */
              data.status = 'COLLECTING';
            }
            const index = data?.ods?.findIndex((item) => item === 'Otro');
            if (index !== -1) {
              data?.ods.splice(index, 1);
            }

            setState({ ...data, ods: odsOrganized(data?.ods) });
          }
        })
        .catch((err) => logCallback(err, () => {
          setIsLoading(false);
          setIsError(true);
          setState({});
        }));
    }
  }, [tag, id]);

  return {
    singleProject: state,
    isLoadingSingleProject: isLoading,
    isErrorSingleProject: isError,
  };
};
